// export const BASE_URL = 'http://localhost:7200';
export const BASE_URL = 'http://visiting.planotechevents.com:7200'
// export const BASE_URL = 'https://147.93.28.177:7200';
// export const BASE_URL = 'http://134.209.152.97:7200';
// export const BASE_URL = 'https://checkin.samyotech.in';
// export const BASE_URL = 'https://authentry.samyotech.in';
const API_VERSION = '/api/v1';

export const urls = Object.freeze({
    endpoints: {
        user: {
            register: `${BASE_URL}${API_VERSION}/user/register`,
            login: `${BASE_URL}${API_VERSION}/user/login/`,
            getUserDetails: `${BASE_URL}${API_VERSION}/user/getuserdetails`,
            updateDetails: `${BASE_URL}${API_VERSION}/user/updateuserdetails`,
            logoUpdate: `${BASE_URL}${API_VERSION}/user/updatecompanylogo`,
            updateUserPassword: `${BASE_URL}${API_VERSION}/user/updateuserpassword`,
            managePermissions: `${BASE_URL}${API_VERSION}/user/manageuserpermission`,
            getAllUser: `${BASE_URL}${API_VERSION}/user/getalluser`,
            getAllCompany: `${BASE_URL}${API_VERSION}/user/getallcompany`,
            getUserById: `${BASE_URL}${API_VERSION}/user/getuserdetailsbyid`,
            updateActiveStatus: `${BASE_URL}${API_VERSION}/user/updateactivestatus`,
            updateUserPasswordBySuperAdmin: `${BASE_URL}${API_VERSION}/user/updateuserpasswordbysuperadmin`,
            manageMail: `${BASE_URL}${API_VERSION}/user/managemail`,
            fetchLogo:`${BASE_URL}${API_VERSION}/user/fetchLogo`
        },
        visitor: {
            createVisitor: `${BASE_URL}${API_VERSION}/visitor/createvisitor`,
            updateVisitor: `${BASE_URL}${API_VERSION}/visitor/updatevisitor`,
            getVisitorDetails: `${BASE_URL}${API_VERSION}/visitor/getvisitordetails`,
            getAllVisitor: `${BASE_URL}${API_VERSION}/visitor/getallvisitor`,
            getDetailsByNumber: `${BASE_URL}${API_VERSION}/visitor/getdetailsbynumber`,
            getVisitorHistory: `${BASE_URL}${API_VERSION}/visitor/getvisitorhistory`,
            bulkUploadVisitor: `${BASE_URL}${API_VERSION}/visitor/bulkuploadvisitor`,
        },
        visits: {
            createEntry: `${BASE_URL}${API_VERSION}/visits/createentry`,
            createEntryUsingApn: `${BASE_URL}${API_VERSION}/visits/createentryusingapn`,
            createEntryUsingPass: `${BASE_URL}${API_VERSION}/visits/createentryusingpass`,
            exitVisitor: `${BASE_URL}${API_VERSION}/visits/updateentry`,
            getAllEntry: `${BASE_URL}${API_VERSION}/visits/getallentry`,
            getEntryByDate: `${BASE_URL}${API_VERSION}/visits/getentrybydate`,
            getDashboardData: `${BASE_URL}${API_VERSION}/visits/getdashboarddata`,
            adminDashboardData: `${BASE_URL}${API_VERSION}/visits/admindashboarddata`,
            adminReport: `${BASE_URL}${API_VERSION}/visits/adminReport`,
            companyEmpCount: `${BASE_URL}${API_VERSION}/visits/companyempcount`,
            superaAdminReport: `${BASE_URL}${API_VERSION}/visits/superadminreport`,
        },
        appointment: {
            scheduleAppointment: `${BASE_URL}${API_VERSION}/appointment/scheduleappointment`,
            reScheduleAppointment: `${BASE_URL}${API_VERSION}/appointment/rescheduleappointment`,
            getAllAppointment: `${BASE_URL}${API_VERSION}/appointment/getallappointment`,
            getAppointmentByDate: `${BASE_URL}${API_VERSION}/appointment/getappointmentbydate`,
            getAppointmentByAptId: `${BASE_URL}${API_VERSION}/appointment/getappointmentbyaptid`,
            updateAppointmentStatus: `${BASE_URL}${API_VERSION}/appointment/updateappointmentstatus`,
            getAppointmentByName: `${BASE_URL}${API_VERSION}/appointment/getappointmentbyname`,
        },
        pass: {
            createPass: `${BASE_URL}${API_VERSION}/pass/createpass`,
            updatePassValidity: `${BASE_URL}${API_VERSION}/pass/updatepassvalidity`,
            getPassByPasscode: `${BASE_URL}${API_VERSION}/pass/getpassbypasscode`,
            getPassByName: `${BASE_URL}${API_VERSION}/pass/getpassbyname`,
            getAllPass: `${BASE_URL}${API_VERSION}/pass/getallpass`,
        },
        subscription: {
            createSubscription: `${BASE_URL}${API_VERSION}/subscription/createsubscription`,
            updateSubscription: `${BASE_URL}${API_VERSION}/subscription/updatesubscription`,
            getAllSubscription: `${BASE_URL}${API_VERSION}/subscription/getallsubscription`,
            upgradeCompanySubscription: `${BASE_URL}${API_VERSION}/subscription/upgradecompanysubscription`,
            updateSubscriptionActiveStatus: `${BASE_URL}${API_VERSION}/subscription/updatesubscriptionactivestatus`,
        },
        payment: {
            createPayment: `${BASE_URL}${API_VERSION}/payment/createpayment`,
            getAllPaymentHistory: `${BASE_URL}${API_VERSION}/payment/getallpaymenthistory`,
            companyPaymentHistory: `${BASE_URL}${API_VERSION}/payment/companypaymenthistory`,
            createCheckoutSession: `${BASE_URL}${API_VERSION}/payment/createcheckoutsession`,
            getCheckoutSessionDetails: `${BASE_URL}${API_VERSION}/payment/getcheckoutsessiondetails`,
            getPaymentHistoryById: `${BASE_URL}${API_VERSION}/payment/getpaymenthistorybyid`,
        }
    }
});